import {
  Bar,
  BarChart as RechartsBarChart,
  CartesianGrid,
  ResponsiveContainer,
  XAxis,
  YAxis,
  Cell,
} from 'recharts';
import { useSelector } from 'react-redux';

import theme from '@css/theme.style.json';

import './bar-chart.styl';

const SHORT_SCREEN_HEIGHT = 720;

function renderYAxisLabel(value, shortScreen) {
  return function ({ viewBox }) {
    const x = viewBox.x + 12;
    const y = shortScreen ? viewBox.y + viewBox.height : viewBox.y + (viewBox.height / 2);

    return (
      <text
        x={x}
        y={y}
        fill={theme.color.common.grey.light}
        textAnchor={shortScreen ? 'start' : 'middle'}
        dominantBaseline="central"
        transform={`rotate(-90, ${x}, ${y})`}
      >
        {value}
      </text>
    );
  };
}

function BarChart({
  data,
  xDataKey,
  yDataKey,
  tickFormatter,
  title,
  yAxisWidth = undefined,
  yDomain = undefined,
  selectedItem = undefined,
  yAxisLabel = undefined,
}) {
  const viewportHeight = useSelector(state => state.windowObserver.viewportHeight);
  const shortScreen = viewportHeight !== null && viewportHeight < SHORT_SCREEN_HEIGHT;

  return (
    <div className="bar-chart">
      {title && (
        <h4 className="bar-chart__title">
          {title}
        </h4>
      )}
      <ResponsiveContainer width="100%">
        <RechartsBarChart data={data}>
          <CartesianGrid vertical={false} />
          <XAxis tickLine={false} dataKey={xDataKey} />
          <YAxis
            tickFormatter={(value, index) => {
              if (tickFormatter) {
                return tickFormatter(value, index);
              }

              return value;
            }}
            tickLine={false}
            width={yAxisWidth}
            domain={yDomain}
            tickCount={4}
            label={yAxisLabel ? { content: renderYAxisLabel(yAxisLabel, shortScreen) } : undefined}
          />
          <Bar
            dataKey={yDataKey}
            fill={theme.color.primary.light}
            label={{ position: 'insideTop', fontSize: 12, fill: theme.color.common.black }}
          >
            {data.map((entry, index) => {
              return (
                <Cell
                  key={`cell-${index}`}
                  fill={entry[xDataKey] === selectedItem ? '#5A99D7' : '#F1FBF2'}
                />
              );
            })}
          </Bar>
        </RechartsBarChart>
      </ResponsiveContainer>
    </div>
  );
}

export default BarChart;
